<template>
  <div class="layout-group">
    <!-- 半透明遮罩 -->
    <div class="layout-mask"></div>
    <!-- 主体内容 -->
    <div class="layout-main" flex="dir:top">
      <!-- 顶栏 -->
      <div class="layout-theme-header" flex-box="0" flex v-if="isMainApp">
        <router-link
          to="/"
          class="logo-group logo-transition"
          flex-box="0"
        >
        </router-link>
        <!-- <div
          v-if="showAside"
          class="toggle-aside-btn"
          @click="handleToggleAside"
          flex-box="0"
        >
          <a>
            <i class="fa fa-bars"></i>
          </a>
        </div> -->
        <!-- 顶栏菜单 -->
        <div class="layout-theme-header-menu" flex-box="1">
          <menuHeader />
        </div>
        <!-- 顶栏右侧 -->
        <div class="layout-theme-header-right" flex-box="0">
          <headerDownload />
          <headerLocales />
          <!-- <headerSetting /> -->
          <headerUser />
          <sidebar />
        </div>
      </div>
      <!-- 页面主体 -->
      <div class="layout-theme-container" flex-box="1" flex>
        <!-- 侧边栏 -->
        <div
          flex-box="0"
          :class="{
            'layout-theme-aside': true,
            'layout-theme-container-transition': asideTransition
          }"
          :collapse="asideCollapse"
        >
          <MenuSideLayer />
        </div>

        <!-- 主体 -->
        <div class="layout-theme-container-main" flex-box="1" flex>
          <!-- tab -->
          <div class="d2-theme-container-main-header" flex-box="0">
            <tabs />
          </div>
          <!-- 内容 -->
          <transition name="fade-scale">
            <div class="layout-theme-container-main-layer-wrapper">
              <div
                class="layout-theme-container-main-layer"
                flex="dir:top"
                :class="layoutClass"
              >
                <!-- <div
                class="layout-theme-container-main-header"
                v-if="$route.meta.head"
                flex-box="0"
              >
                <headerTitle />
              </div> -->
                <!-- 页面 -->
                <div class="layout-theme-container-main-body" flex-box="1" :class="bodyClass">
                  <transition :name="transitionActive ? 'fade-transverse' : ''">
                    <keep-alive :include="keepAlive">
                      <router-view :key="routerViewKey" />
                    </keep-alive>
                  </transition>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>

      <headerUploader />
    </div>
  </div>
</template>
<script>
import MenuSideLayer from './components/menu-side/layer.vue'
import menuHeader from './components/menu-header'
import tabs from './components/tabs'
import headerDownload from './components/header-download'
import headerUploader from './components/header-uploader/fixed'
import headerLocales from './components/header-locales'
import headerUser from './components/header-user'
// import headerSetting from './components/header-setting'
import sidebar from './components/sidebar'
// import headerTitle from './components/header-title'
import { mapState, mapActions } from 'vuex'
export default {
  components: {
    MenuSideLayer,
    menuHeader,
    tabs,
    headerLocales,
    headerDownload,
    headerUploader,
    headerUser,
    // headerSetting,
    sidebar
    // headerTitle
  },
  data() {
    return {
      // [侧边栏宽度] 正常状态
      asideWidth: '220px',
      // [侧边栏宽度] 折叠状态
      asideWidthCollapse: '65px'
    }
  },
  computed: {
    isMainApp() {
      return !window.__POWERED_BY_WUJIE__
    },
    ...mapState('admin', {
      keepAlive: (state) => state.page.keepAlive,
      grayActive: false,
      transitionActive: true,
      asideCollapse: (state) => state.menu.asideCollapse,
      asideTransition: (state) => state.menu.asideTransition
    }),
    /**
     * @description 用来实现带参路由的缓存
     */
    routerViewKey() {
      // 默认情况下 key 类似 __transition-n-/foo
      // 这里的字符串操作是为了最终 key 的格式和原来相同 类似 __transition-n-__stamp-time-/foo
      const stamp = this.$route.meta[`__stamp-${this.$route.path}`] || ''
      return `${stamp ? `__stamp-${stamp}-` : ''}${this.$route.path}`
    },
    layoutClass() {
      const { pageConfig } = this.$route.meta
      const { layout } = pageConfig || {}
      return layout?.class || ''
    },
    bodyClass() {
      const { pageConfig } = this.$route.meta
      const { body } = pageConfig || {}
      return body?.class || ''
    },
  },
  methods: {
    ...mapActions('admin/menu', ['asideCollapseToggle']),
    /**
     * 接收点击切换侧边栏的按钮
     */
    handleToggleAside() {
      this.asideCollapseToggle()
    }
  }
}
</script>

<style lang="scss">
// 注册主题
@import '~@/assets/style/theme/register.scss';
</style>
